var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 14.6875C15.8875 14.6875 18.125 12.45 18.125 9.6875C18.125 6.925 15.8875 4.6875 13.125 4.6875C10.3625 4.6875 8.125 6.925 8.125 9.6875C8.125 12.45 10.3625 14.6875 13.125 14.6875ZM13.125 7.1875C14.5 7.1875 15.625 8.3125 15.625 9.6875C15.625 11.0625 14.5 12.1875 13.125 12.1875C11.75 12.1875 10.625 11.0625 10.625 9.6875C10.625 8.3125 11.75 7.1875 13.125 7.1875ZM5.625 22.1875C5.875 21.4 8.8375 20.0875 11.825 19.7625L14.375 17.2625C13.8875 17.2125 13.525 17.1875 13.125 17.1875C9.7875 17.1875 3.125 18.8625 3.125 22.1875V24.6875H14.375L11.875 22.1875H5.625ZM25.125 15.3125L18.7125 21.775L16.125 19.175L14.375 20.9375L18.7125 25.3125L26.875 17.075L25.125 15.3125Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPresent);
export default __webpack_public_path__ + "static/media/Total Present.d27978a77b516ddfa82feeba8f49b1ab.svg";
export { ForwardRef as ReactComponent };